/**
 * @var ScriptData
 */

var Choices = require( 'choices.js' );

var forms = ( function ($) {

	var forms;

	var choices = {};

	var _init = function ( e ) {
		forms = document.getElementsByClassName( 'crate-form' );

		if ( forms.length > 0 ) {
			if (typeof grecaptcha !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute( ScriptData.recaptcha_site_key, { action: 'contact' } ).then( function ( token ){
						for ( var _grc_form_key in forms ) {
					        if ( !forms.hasOwnProperty( _grc_form_key ) ) {
								continue;
							}

							var $_grc_form = $( forms[_grc_form_key] );

							if ($_grc_form.hasClass('use-recaptcha')) {
								$_grc_form.data('recaptcha-token', token);
							}
					    }
					});
				});
			}

			for ( var form_key in forms ) {
				if ( !forms.hasOwnProperty( form_key ) ) {
					continue;
				}

				forms[form_key].addEventListener( 'submit', _submit );

				var fields = _get_fields( forms[form_key] );

				for ( var field_key in fields ) {
					if ( !fields.hasOwnProperty( field_key ) ) {
						continue;
					}

					if ( 'select' === fields[field_key].nodeName.toLowerCase() ) {
						choices[ fields[field_key].getAttribute( 'id' ) ] = new Choices( fields[field_key], {
							shouldSort: false
						} );
					}

					_set_up_conditional( forms[form_key], fields[field_key] );

					fields[field_key].addEventListener( 'change', _field_change );
				}
			}

			var tooltips = document.getElementsByClassName( 'crate-tooltip' );

			for ( var tooltip_key in tooltips ) {
				if ( !tooltips.hasOwnProperty( tooltip_key ) ) {
					continue;
				}

				tooltips[tooltip_key].getElementsByClassName( 'tooltip-icon' )[0].addEventListener( 'click', _maybe_show_tooltip );
				tooltips[tooltip_key].getElementsByClassName( 'tooltip-close' )[0].addEventListener( 'click', _hide_tooltip_event );
			}
		}

		var save_buttons = document.getElementsByClassName( 'save-form' );

		if ( save_buttons.length ) {
			for ( var save_button_key in save_buttons ) {
				if ( ! save_buttons.hasOwnProperty( save_button_key ) ) {
					continue;
				}

				var save_button = save_buttons[ save_button_key ];

				save_button.addEventListener( 'click', _save_button_event );
			}
		}
	};

	var _recaptcha = function(forms) {

	};

	var _set_up_conditional = function( form, field ) {
		var $form  = $( form );
		var $field = $( field );

		var conditional = $field.closest( '.field-wrap' ).data( 'conditional' );

		if ( conditional ) {
			var $conditional_field = $( '#' + $form.attr( 'id' ) + '-' + conditional.field );
			$conditional_field.data( 'conditional-for', $field.attr( 'id' ) );
			$conditional_field.on( 'change', _maybe_show_conditional_event );

			_maybe_show_conditional( $field, conditional );
		}
	};

	var _maybe_show_conditional = function( $field, conditional ) {
		var $conditional_field = $( '#' + $field.closest( '.crate-form' ).attr( 'id' ) + '-' + conditional.field );

		if ( conditional.value === $conditional_field.val() ) {
			$field.closest( '.field-wrap' ).removeClass( 'hidden' );
		} else {
			$field.closest( '.field-wrap' ).addClass( 'hidden' );
		}
	};

	var _maybe_show_conditional_event = function( e ) {
		var $current_field = $( this );
		var $field_to_hide = $( '#' + $current_field.data( 'conditional-for' ) );

		_maybe_show_conditional( $field_to_hide, $field_to_hide.closest( '.field-wrap' ).data( 'conditional' ) );
	};

	var _save_button_event = function( e ) {
		e.preventDefault();

		var form_id = this.dataset.form;
		var redirect = this.dataset.redirect;
		redirect = typeof redirect === 'undefined' ? false : redirect;

		var form = document.getElementById( form_id );

		_post_data( form, false, true, redirect )
	};

	var _maybe_show_tooltip = function ( e ) {
		if ( !this.parentNode.classList.contains( 'open' ) ) {
			_show_tooltip( this.parentNode );
		}
	};

	var _hide_tooltip_event = function ( e ) {
		e.preventDefault();

		_hide_tooltip( this.closest( '.crate-tooltip' ) );
	};

	var _hide_tooltip = function ( tooltip ) {
		tooltip.classList.remove( 'open' );
	};

	var _show_tooltip = function ( tooltip ) {
		tooltip.classList.add( 'open' );
	};

	var _get_fields = function ( form ) {
		return form.getElementsByClassName( 'crate-field' );
	};

	var _get_field_values = function ( form ) {
		var fields = _get_fields( form );

		var values = {};

		for ( var field_key in fields ) {
			if ( !fields.hasOwnProperty( field_key ) ) {
				continue;
			}

			var field_name = fields[field_key].getAttribute( 'name' );
			var value_key = field_name.replace( form.getAttribute( 'id' ) + '-', '' );

			values[value_key] = _get_field_value( form, field_name );
		}

		return values;
	};

	var _get_field_value = function ( form, field_name ) {
		var fields = form.querySelectorAll( '[name="' + field_name + '"]' );

		if ( !fields.length > 0 ) {
			return null;
		}

		if ( fields.length > 1 ) {
			var type = fields[0].getAttribute( 'type' );
			var value = [];

			for ( var field_key in fields ) {
				if ( !fields.hasOwnProperty( field_key ) ) {
					continue;
				}

				if ( fields[field_key].checked ) {
					if ( 'checkbox' === type ) {
						value.push( fields[field_key].value );
					} else {
						return fields[field_key].value;
					}
				}
			}

			return value;
		} else {
			var field = fields[0];

			if ( 'checkbox' === field.getAttribute( 'type' ) ) {
				return field.checked ? [ field.value ] : [];
			}

			return fields[0].value;
		}
	};

	var _get_nonce = function ( form ) {
		return _get_field_value( form, '_wpnonce' );
	};

	var _field_change = function ( e ) {
		_post_data( this.closest( 'form' ), true );
	};

	var _submit = function ( e ) {
		e.preventDefault();

		_post_data( this, false );
	};

	var _post_data = function ( form, autosave, manual_save, redirect ) {
		autosave = typeof autosave !== 'undefined' ? autosave : false;
		manual_save = typeof manual_save !== 'undefined' ? manual_save : false;
		redirect = typeof redirect !== 'undefined' ? redirect : false;

		var values = _get_field_values( form );

		if ( !autosave && ! manual_save ) {
			form.classList.add( 'show-notices' );
		}

		if ( ! autosave || manual_save ) {
			_show_spinner( form );
		}

		var request = new XMLHttpRequest();

		request.open( 'POST', ScriptData.ajaxurl, true );
		request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded;' );
		request.onload = _post_data_response;

		var $form = $( form );

		var data = {
			action: 'crate_submit_form',
			form_id: form.getAttribute( 'id' ),
			nonce: _get_nonce( form ),
			current_uri: window.location.href,
			autosave: autosave,
			values: values,
			manual_save: manual_save,
			redirect: redirect,
			recaptcha_token: $form.data( 'recaptcha-token' ) ? $form.data( 'recaptcha-token' ) : false
		};

		console.log($form.data('recaptcha-token'));

		request.send( 'action=crate_submit_form&form_data=' + encodeURIComponent( JSON.stringify( data ) ) );
	};

	var _post_data_response = function () {
		var response = JSON.parse( this.response );
		var form = document.getElementById( response.form_id );

		if ( ! response.manual_save && form.classList.contains( 'show-notices' ) ) {
			_display_field_errors( response.form_id, response.field_errors );
			_display_form_errors( response.form_id, response.form_errors );
		}

		_display_field_notices( response.form_id, response.field_notices );
		_display_form_notices( response.form_id, response.form_notices );

		_update_field_values( response.form_id, response.updated_values );
		_hide_fields( response.form_id, response.hide_fields );

		var error_div = form.getElementsByClassName( 'form-errors' )[0];
		var notices_div = form.getElementsByClassName( 'form-notices' )[0];
		var did_scroll = false;

		if ( ! response.autosave && ( error_div.classList.contains( 'has-errors' ) || notices_div.classList.contains( 'has-notices' ) ) ) {
			$( 'html, body' ).animate( {
				scrollTop: $(form).offset().top - 150
			}, 1000 );

			did_scroll = true;
		}

		if ( response.redirect ) {
			var timeout = did_scroll ? 1500 : 500;
			setTimeout( function () {
				window.location.href = response.redirect
			}, timeout );
		} else {
			_hide_spinner( document.getElementById( response.form_id ) );
		}
	};

	var _update_field_values = function ( form_id, values ) {
		for ( var field in values ) {
			if ( !values.hasOwnProperty( field ) ) {
				continue;
			}

			document.getElementById( form_id + '-' + field ).value = values[ field ];
		}
	};

	var _hide_fields = function ( form_id, fields ) {
		for ( var field in fields ) {
			if ( !fields.hasOwnProperty( field ) ) {
				continue;
			}

			var el = document.getElementById( form_id + '-field-wrap-' + field );

			if ( fields[ field ] ) {
				el.classList.add( 'js-hide' );
			} else {
				el.classList.remove( 'js-hide' );
			}
		}
	};

	var _display_field_errors = function ( form_id, errors ) {
		for ( var field in errors ) {
			if ( !errors.hasOwnProperty( field ) ) {
				continue;
			}

			var field_wrap = document.getElementById( form_id + '-field-wrap-' + field );

			var error_div = field_wrap.getElementsByClassName( 'field-errors' )[0];

			field_wrap.classList.remove( 'has-errors' );
			error_div.classList.remove( 'has-errors' );
			while ( error_div.firstChild ) {
				error_div.removeChild( error_div.firstChild );
			}

			for ( var error_key in errors[field] ) {
				if ( !errors[field].hasOwnProperty( error_key ) ) {
					continue;
				}

				var existing_error = error_div.getElementsByClassName( error_key );

				if ( existing_error.length > 0 ) {
					existing_error[0].parentNode.removeChild( existing_error[0] );
				}

				// TODO: Get this to work with vanilla JS

				// var new_error = document.createElement( 'span' );
				// new_error.classList.add( error_key );
				// new_error.innerHtml = errors[field][error_key];

				$( error_div ).append( '<span class="' + error_key + '">' + errors[field][error_key] + '</span>' );
				// error_div.appendChild( new_error );
			}

			if ( error_div.firstChild ) {
				field_wrap.classList.add( 'has-errors' );
				error_div.classList.add( 'has-errors' );
			}
		}
	};

	var _display_field_notices = function ( form_id, notices ) {
		for ( var field in notices ) {
			if ( !notices.hasOwnProperty( field ) ) {
				continue;
			}

			var field_wrap = document.getElementById( form_id + '-field-wrap-' + field );
			var notice_div = field_wrap.getElementsByClassName( 'field-notices' )[0];

			field_wrap.classList.remove( 'has-notices' );
			notice_div.classList.remove( 'has-notices' );
			while ( notice_div.firstChild ) {
				notice_div.removeChild( notice_div.firstChild );
			}

			for ( var notice_key in notices[field] ) {
				if ( !notices[field].hasOwnProperty( notice_key ) ) {
					continue;
				}

				var existing_notice = notice_div.getElementsByClassName( notice_key );

				if ( existing_notice.length > 0 ) {
					existing_notice[0].parentNode.removeChild( existing_notice[0] );
				}

				var new_notice = document.createElement( 'span' );
				new_notice.classList.add( notice_key );
				new_notice.appendChild( document.createTextNode( notices[field][notice_key] ) );

				notice_div.appendChild( new_notice );
			}

			if ( notice_div.firstChild ) {
				field_wrap.classList.add( 'has-notices' );
				notice_div.classList.add( 'has-notices' );
			}
		}
	};

	var _display_form_errors = function ( form_id, errors ) {
		var form = document.getElementById( form_id );
		var error_div = form.getElementsByClassName( 'form-errors' )[0];

		error_div.classList.remove( 'has-errors' );
		while ( error_div.firstChild ) {
			error_div.removeChild( error_div.firstChild );
		}

		for ( var error_key in errors ) {
			if ( !errors.hasOwnProperty( error_key ) ) {
				continue;
			}

			var existing_error = error_div.getElementsByClassName( error_key );

			if ( existing_error.length > 0 ) {
				existing_error[0].parentNode.removeChild( existing_error[0] );
			}

			var new_error = document.createElement( 'span' );
			new_error.classList.add( error_key );
			new_error.appendChild( document.createTextNode( errors[error_key] ) );

			error_div.appendChild( new_error );
		}

		if ( error_div.firstChild ) {
			error_div.classList.add( 'has-errors' );
		}
	};

	var _display_form_notices = function ( form_id, notices ) {
		var form = document.getElementById( form_id );
		var notice_div = form.getElementsByClassName( 'form-notices' )[0];

		notice_div.classList.remove( 'has-notices' );
		while ( notice_div.firstChild ) {
			notice_div.removeChild( notice_div.firstChild );
		}

		for ( var notice_key in notices ) {
			if ( !notices.hasOwnProperty( notice_key ) ) {
				continue;
			}

			var existing_notice = notice_div.getElementsByClassName( notice_key );

			if ( existing_notice.length > 0 ) {
				existing_notice[0].parentNode.removeChild( existing_notice[0] );
			}

			var new_notice = document.createElement( 'span' );
			new_notice.classList.add( notice_key );
			new_notice.appendChild( document.createTextNode( notices[notice_key] ) );

			notice_div.appendChild( new_notice );
		}

		if ( notice_div.firstChild ) {
			notice_div.classList.add( 'has-notices' );
		}
	};

	var _show_spinner = function ( form ) {
		document.body.classList.add( 'crate-loading' );
		var spinners = form.getElementsByClassName( 'ajax-spinner' );

		for ( var spinner in spinners ) {
			if ( !spinners.hasOwnProperty( spinner ) ) {
				continue;
			}

			var spinner_node = spinners[spinner];

			spinner_node.classList.add( 'active' );
		}
	};

	var _hide_spinner = function ( form ) {
		document.body.classList.remove( 'crate-loading' );
		var spinners = form.getElementsByClassName( 'ajax-spinner' );

		for ( var spinner in spinners ) {
			if ( !spinners.hasOwnProperty( spinner ) ) {
				continue;
			}

			var spinner_node = spinners[spinner];

			spinner_node.classList.remove( 'active' );
		}
	};

	document.addEventListener( 'DOMContentLoaded', _init );

	return {
		choices: choices
	}

})(jQuery);

module.exports = forms;